var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableIconInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.094,
    height: 14.393,
    viewBox: "0 0 22.094 14.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2583",
    "data-name": "Caminho 2583",
    d: "M252.06,237.486a.263.263,0,0,1-.205.314.27.27,0,0,1-.323-.2l-1-4.345H246.62l-1.266,4.358a.27.27,0,0,1-.26.192.287.287,0,0,1-.074-.01.263.263,0,0,1-.187-.325l1.247-4.536-1.247-4.56a.314.314,0,0,1-.008-.045l-.17-1.578c-.014-.145.03-.275.179-.288a1.082,1.082,0,0,1,.646.484l.2,1.775.941,4.007h4.129a.268.268,0,0,1,.263.205Zm-5.98-7.162c-.138-.595-.279-1.346-.4-1.878.2-1.478-.138-1.773-.321-1.813l-.019,0-.321.319Zm2.91,1.949c-.7,0-.585.257-.949.458h2.781A4.27,4.27,0,0,0,248.99,232.272Zm10.289,5.279-2.415-1.448a.8.8,0,0,0-.163-.07l2.786-5.166H253.25l2.787,5.166a.813.813,0,0,0-.164.071l-2.414,1.448c-.273.163-.31.3-.083.3a2.171,2.171,0,0,0,.908-.3l1.589-.953a1.064,1.064,0,0,1,.991,0l1.589.953a2.171,2.171,0,0,0,.909.3C259.588,237.848,259.551,237.714,259.279,237.551Zm-10-6.927h14.175a.288.288,0,0,0,.292-.283v-.018a.288.288,0,0,0-.292-.283H249.281a.288.288,0,0,0-.291.283v.018A.288.288,0,0,0,249.281,230.624Z",
    transform: "translate(-243.153 -224.955)",
    fill: "#8e8e93",
    stroke: "#8e8e93",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIconInactive);
export default __webpack_public_path__ + "static/media/table-icon-inactive.2a07af63.svg";
export { ForwardRef as ReactComponent };